import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import "../styles/admincontent.css";
import AppLayout from "../layouts/AppLayout.jsx";
import Sidebar from "../layouts/components/Sidebar.jsx";
import useChangeLanguage from "../../logic/useChangeLanguage.js";

const ContentSection = () => {
  const { headerId, contentId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [adminContent, setAdminContent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("");
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("onpr_language") || "fr";
  });

  const { _t, getArticleTitle, getArticleDescription } = useChangeLanguage();

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.adminHeaders,
    isLoading: state.apiData?.loading?.adminHeaders,
  }));

  useEffect(() => {
    if (!data) {
      dispatch(
        fetchApiData({
          url: "adminheades",
          itemKey: "adminHeaders",
        })
      );
    }
  }, []);

  useEffect(() => {
    if (data) {
      const header = data.find((h) => h.id === parseInt(headerId));
      if (header) {
        setHeaderTitle(getArticleTitle(header));
        const content = header.admin_contents?.find(
          (c) => c.id === parseInt(contentId)
        );
        if (content) {
          setAdminContent(content);
        }
      }
    }
  }, [data, headerId, contentId, currentLang]);

  const handleBack = () => {
    history.push("/");
  };

  const getTitle = () => {
    if (!adminContent) return "";
    return getArticleTitle(adminContent);
  };

  const getDescription = () => {
    if (!adminContent) return "";
    // let description = getArticleDescription(adminContent);
    // console.log(description);
    return getArticleDescription(adminContent);
  };

  if (isLoading) {
    return (
      <div className="admin-content-screen">
        <div className="loading-container">
          <i
            className="pi pi-spin pi-spinner"
            style={{ fontSize: "3rem", color: "#00a652" }}
          ></i>
          <p>Chargement du contenu...</p>
        </div>
      </div>
    );
  }

  if (!adminContent) {
    return (
      <div className="admin-content-screen">
        <div className="error-container">
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: "3rem", color: "#d32f2f" }}
          ></i>
          <h2>Contenu introuvable</h2>
          <p>Le contenu demandé n'existe pas ou a été supprimé.</p>
          <button className="back-btn" onClick={handleBack}>
            <i className="pi pi-arrow-left"></i> Retour
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-content-screen">
      <article className="content-body">
        <div className="content-meta">
          <span className="content-category">
            <i className="pi pi-folder"></i> {headerTitle}
          </span>
          <span className="content-date">
            <i className="pi pi-calendar"></i>{" "}
            {new Date(adminContent.created_at).toLocaleDateString("fr-FR")}
          </span>
        </div>

        <h1 className="content-title">{getTitle()}</h1>
        <div
          className="content-description"
          dangerouslySetInnerHTML={{ __html: getDescription() }}
        ></div>
      </article>
    </div>
  );
};

const AdminContentScreen = () => {
  return (
    <AppLayout>
      <div>
        <div className="container-admin">
          <Sidebar />

          <ContentSection />
          {/* <aside className="right-sidebar">
                                    <QuickLinks />
                                    <PhotoWeek />
                                </aside> */}
        </div>
      </div>
    </AppLayout>
  );
};

export default AdminContentScreen;
